/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, Table, ValueCell } from '@/wpt-lib/pdf/common/Table';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';

const MeetingDates = ({
    planningMeetingDate,
    progressReviewMeetingDate,
    endOfYearMeetingDate,
}: {
    planningMeetingDate: string | null;
    progressReviewMeetingDate: string | null;
    endOfYearMeetingDate: string | null;
}) => {
    return (
        <Table cols={3}>
            <Row>
                <SubHeading level={2} text="Scheduled Meeting Dates" />
            </Row>
            <Row widths={[33, 33, 34]}>
                <ValueCell label="Planning" value={planningMeetingDate} format="date" />
                <ValueCell label="Progress Review" value={progressReviewMeetingDate} format="date" />
                <ValueCell label="End Year" value={endOfYearMeetingDate} format="date" />
            </Row>
        </Table>
    );
};

export default MeetingDates;
